export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Automotive technicians, mechanics, trainees and professionals who work with gasoline engine diagnostics.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. GASOLINE ENGINE DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer: 'No. It is a practical diagnostic and reference system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on organized diagnostic references, troubleshooting paths, system comparisons, test procedures and fault-finding tools.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Gasoline engine fundamentals, fuel injection, ignition, misfires, sensors, engine management, emissions, VVT, drivability and advanced diagnostic testing.',
  },
  {
    question: 'Does this replace manufacturer service information?',
    answer:
      'No. It is a diagnostic reference resource and does not replace OEM specifications, service procedures, safety requirements or professional judgment.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Does it work for any vehicle make or model?',
    answer:
      'The system is organized by symptom and by system — fuel, ignition, air intake, sensors, emissions and VVT — so the diagnostic logic applies across makes and models. Specific values and procedures must always be confirmed against the manufacturer service information for the vehicle in the bay.',
  },
  {
    question: 'Do I need special diagnostic equipment to use it?',
    answer:
      'No special equipment is required. The references are built around common workshop tools such as a scan tool, multimeter, fuel-pressure gauge and vacuum gauge, and show how to interpret the readings and what to test next. Oscilloscope sections are included for technicians who use one.',
  },
  {
    question: 'Can I use it on a phone or tablet in the workshop?',
    answer:
      'Yes. It is a digital resource you can open on a phone, tablet, laptop or desktop, so the diagnostic references stay available at the vehicle while you work.',
  },
]
